import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { TestComponent } from './test.component';
import { TestInputsComponent } from './test-inputs/test-inputs.component';
import { TestDropdownsComponent } from './test-dropdowns/test-dropdowns.component';
import { TestDatesComponent } from './test-dates/test-dates.component';
import { TestButtonsComponent } from './test-buttons/test-buttons.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TestGridsComponent } from './test-grids/test-grids.component';

@NgModule({
  declarations: [
    TestComponent,
    TestInputsComponent,
    TestDropdownsComponent,
    TestDatesComponent,
    TestButtonsComponent,
    TestGridsComponent
  ],
  imports: [
    SharedModule,
    NgbModule
  ]
})
export class TestModule { }
